import * as constants from '../AppConstants';
import RestClient from '../dataclient/RestClient';

export function setAuthenticationState(isAuthenticated, onLogin, onLogout) {
    return {
        type: constants.SET_AUTHENTICATION_STATE,
        isAuthenticated: isAuthenticated,
        onLogin: onLogin,
        onLogout: onLogout
    };
}

export function initialize(config) {
    return {
        type: constants.INITIALIZE_APP,
        config: config
    }
}

export function terminate() {
    return {
        type: constants.TERMINATE_APP
    }
}

export function initDataClient(dataClient) {
    return {
        type: constants.INIT_DATA_CLIENT,
        dataClient: dataClient
    }
}

export function cacheResources(resourceEntities) {
    return {
        type: constants.LOAD_CACHE,
        resourceEntities: resourceEntities
    }
}

export function failCache(reason) {
    return {
        type: constants.FAIL_CACHE,
        reason: reason
    }
}

export function setViewState(siteId, viewKey, options, data) {
    return {
        type: constants.SET_VIEW_STATE,
        siteId: siteId,
        viewKey: viewKey,
        options: options,
        data: data
    };
}

export function setLanguage(language) {
    return {
        type: constants.SET_LANGUAGE,
        language: language
    }
}


export function onSetAuthenticationState(isAuthenticated, onLogin, onLogout) {
    return (dispatch, getState) => {
        dispatch(setAuthenticationState(isAuthenticated, onLogin, onLogout));
    }
}

export function onSetLanguage(language) {
    return (dispatch, getState) => {
        dispatch(setLanguage(language));
    }
}

export function onInitialize(isAuthenticated, onLogin, onLogout) {
    let configPath = constants.FETCH_BASE_PATH + constants.FETCH_CONFIG_PATH;

    /*return (dispatch, getState) => {
        fetch(configPath, {
            accept: "application/text"
        }).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response;
            }
            const error = new Error(`HTTP Error ${response.statusText}`);
            error.status = response.statusText;
            error.response = response;
            console.log(error);
            throw error;
        }).then((response) => {
            return response.json();
        }).then((config) => {
            dispatch(initialize(config));
        }).then(() => {
            dispatch(initDataClient(new RestClient(getState().appState.serverConfig.rest)));
        }).then(() => {
            // Load all resources for a specified farm identifier
            getState().appState.dataClient.getAllResources(
                {farmId: getState().appState.farmId},
                resources => {
                    dispatch(cacheResources(resources));
                },
                reason => {
                    dispatch(failCache(reason))
                }
            );
        });
    }*/
}

export function onTerminate() {
    return (dispatch, getState) => {
        dispatch(terminate());
    }
}

export function onSetViewState(siteId, viewKey, options) {
    return (dispatch, getState) => {
        let appState = getState().appState;
        let dataClient = appState.dataClient;

        if (viewKey === constants.CONDITIONS_VIEW ||
            viewKey === constants.GRIDS_VIEW) {
            dataClient.fetchSiteMetricsAndAlerts(siteId, options,
                result => {
                    dispatch(setViewState(siteId, viewKey, options, result));
                },
                reason => {
                    dispatch(failCache(reason))
                }
            );
        } else if (viewKey === constants.SENSORS_VIEW) {
            dataClient.fetchGraphForViewState(siteId, options, constants.SENSOR_STATUS_GRAPH_ID,
                data => {
                    let result =  data.sensors.map(node => {
                        return node.metricValue;
                    });

                    dispatch(setViewState(siteId, viewKey, options, result));
                },
                reason => {
                    dispatch(failCache(reason))
                }
            );
        } else if (viewKey === constants.ANALYSIS_VIEW && options.chartKey === constants.SERIES_CHART) {
            dataClient.fetchTimeSeriesData(siteId, options,
                result => {
                    dispatch(setViewState(siteId, viewKey, Object.assign(options), result));
                },
                reason => {
                    dispatch(failCache(reason))
                }
            );
        } else if (viewKey === constants.ANALYSIS_VIEW && options.chartKey === constants.VELOCITY_CHART) {
            dataClient.fetchVectorSeriesData(siteId, options,
                result => {
                    dispatch(setViewState(siteId, viewKey, Object.assign(options), result));
                },
                reason => {
                    dispatch(failCache(reason))
                }
            );
        }  else if (viewKey === constants.ALERTS_VIEW) {
            dataClient.fetchAlertsForViewState(siteId, options,
                result => {
                    dispatch(setViewState(siteId, viewKey, Object.assign(options), result));
                },
                reason => {
                    dispatch(failCache(reason))
                }
            );
        }  else if (viewKey === constants.LIVE_METRICS_VIEW) {
            dataClient.fetchLiveSiteMetrics(siteId, options,
                result => {
                    dispatch(setViewState(siteId, viewKey, options, result));
                },
                reason => {
                    dispatch(failCache(reason))
                }
            );
        }else {
            dispatch(setViewState(siteId, viewKey, options, undefined));
        }
    }

}
